import { WORDS } from "./words";
import type { ExamId } from "../lib/types";

export interface ExamProfile {
  id: ExamId;
  label: string;
  /** 考試目標詞數（長期目標，與目前實際可用詞數分開顯示） */
  targetWords: number;
  /** 目前實際可學的詞（取自本機詞庫） */
  corpusWordIds: string[];
}

const corpusIds = WORDS.map((word) => word.id);

export const EXAM_PROFILES: Record<ExamId, ExamProfile> = {
  hkdse: { id: "hkdse", label: "HKDSE English", targetWords: 3000, corpusWordIds: corpusIds },
  ielts: { id: "ielts", label: "IELTS", targetWords: 4500, corpusWordIds: corpusIds },
  toefl: { id: "toefl", label: "TOEFL", targetWords: 5000, corpusWordIds: corpusIds },
  custom: { id: "custom", label: "自訂詞單", targetWords: WORDS.length, corpusWordIds: corpusIds },
};